// @flow
export { default } from './CreditCardForm';
export type { Props } from './CreditCardForm';



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/CreditCardForm/index.js